import React, { FC, useEffect } from 'react';
import TrainingLogPageHeader from '../../components/training-log-page-header/training-log-page-header.component';
import { useTrainingLogContext } from '../../training-log.context';
import StatGrid from '../../../../components/stat-grid/stat-grid.component';
import SeasonOverviewChart from '../../../../components/season-overview-chart/season-overview-chart.component';
import PeriodSummary from '../../../../components/period-summary/period-summary.component';
import TrainingZoneBreakdown from '../../../../components/training-zone-breakdown/training-zone-breakdown.component';
import SportBreakdown from '../../../../components/sport-breakdown/sport-breakdown.component';
import SportTypeBreakdown from '../../../../components/sport-type-breakdown/sport-type-breakdown.component';
import FocusBreakdown from '../../../../components/focus-breakdown/focus-breakdown.component';
import TeamAttendanceBreakdown from '../../../../components/team-attendance-breakdown/team-attendance-breakdown.component';
import useSnackbarHelper from '../../../../hooks/snackbar.hook';
import './dashboard.page.css';

const DashboardPage: FC = () => {
  const { stats, loading, error, attendanceTeams, attendanceLoading, hideAttendance, onNavigateToTrainingLog } =
    useTrainingLogContext();
  const { showSnackbar } = useSnackbarHelper();

  useEffect(() => {
    if (error) {
      showSnackbar('There was an error loading your training stats. Please try again later.', 'error');
    }
  }, [error, showSnackbar]);

  return (
    <div className="dashboard-page">
      <TrainingLogPageHeader
        title="Dashboard"
        subtitle="Season summary, trends, and analytics at a glance"
        showSeasonDateRange
      />

      <StatGrid stats={stats} loading={loading} />
      <SeasonOverviewChart stats={stats} loading={loading} />
      <PeriodSummary
        stats={stats}
        loading={loading}
        attendanceTeams={hideAttendance ? null : attendanceTeams}
        attendanceLoading={hideAttendance ? false : attendanceLoading}
        onNavigateToTrainingLog={onNavigateToTrainingLog}
      />
      <TrainingZoneBreakdown stats={stats} loading={loading} />
      <SportBreakdown stats={stats} loading={loading} />
      <SportTypeBreakdown stats={stats} loading={loading} />
      <FocusBreakdown stats={stats} loading={loading} />
      {!hideAttendance && <TeamAttendanceBreakdown attendanceTeams={attendanceTeams} loading={attendanceLoading} />}
    </div>
  );
};

export default DashboardPage;
